import * as React from "react";
import { SVGProps } from "react";
const TribunalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
    <path fill="#B3B9BE" d="M0 15.187h16.727V16H0v-.813ZM.429 14.373h15.87v.813H.428v-.813Z" />
    <path fill="#868E95" d="M.858 14.169h15.011v.203H.859v-.203Z" />
    <path fill="#B3B9BE" d="M1.287 13.355H15.44v.814H1.287v-.814Z" />
    <path
      fill="#868E95"
      d="M1.716 12.745h3.002v.61H1.716v-.61ZM1.716 5.218h3.002v.814H1.716v-.814Z"
    />
    <path
      fill="#CFD4D9"
      d="M2.145 6.032h2.144v6.713H2.145V6.032ZM7.291 6.032h2.145v6.713H7.29V6.032ZM12.438 6.032h2.145v6.713h-2.145V6.032Z"
    />
    <path
      fill="#868E95"
      d="M6.862 12.745h3.003v.61H6.862v-.61ZM6.862 5.218h3.003v.814H6.862v-.814ZM12.01 12.745h3.002v.61h-3.003v-.61ZM12.01 5.218h3.002v.814h-3.003v-.814Z"
    />
    <path
      fill="#B3B9BE"
      d="M8.138.06a.449.449 0 0 1 .451 0l7.592 4.456c.367.215.206.753-.226.753H.772c-.432 0-.593-.538-.226-.753L8.138.06Z"
    />
  </svg>
);
export default TribunalIcon;
